import {
  FormControl,
  IconButton,
  InputBaseComponentProps,
  InputLabel,
  Select,
  Typography,
} from "@mui/material"
import React from "react"
import { Control, Controller } from "react-hook-form"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import { selectSx } from "./SelectRequiredStyle"
import {
  labelSx,
  TextFieldRequiredOverrides,
  TextFieldRequiredScheme,
} from "./TextFieldRequiredStyle"

export interface IValidationTextFieldProp {
  control: Control<any, any>
  fieldName: string
  label: string
  required?: boolean
  children: string | JSX.Element | JSX.Element[]
  inputProps?: InputBaseComponentProps
  backgroundColorTitle?: string | undefined
  size?: "small"
  onFieldExit?: () => void
  variant?: "default" | "labeled" | "rounded"
  disabled?: boolean
  borderRadius?: number | string
  scheme?: TextFieldRequiredScheme
  overrides?: TextFieldRequiredOverrides
}

function SelectRequired({
  control,
  fieldName,
  label,
  required,
  children,
  onFieldExit,
  inputProps,
  backgroundColorTitle,
  size,
  variant = "default",
  disabled,
  borderRadius,
  scheme,
  overrides,
}: IValidationTextFieldProp) {
  const { register } = control

  const [open, setOpen] = React.useState(false)

  const labeled = variant === "labeled"

  if (required === undefined || required === null) {
    required = true
  }

  register(fieldName, { required })

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error, isValidating },
        formState,
      }) => {
        const errored = Boolean(error)
        const val = (value ?? "") as string
        const filled = val !== ""
        const shouldShrink = true

        return (
          <FormControl
            fullWidth
            error={errored}
            disabled={disabled}
            sx={{ pt: size === "small" ? 0.2 : undefined }}
          >
            {variant === "labeled" ? (
              <Typography
                gutterBottom
                fontSize="14px"
                fontWeight={500}
                lineHeight="18px"
                color="black"
                sx={labelSx({
                  labeled,
                  shouldShrink,
                  backgroundColorTitle,
                  startAdornment: null,
                  filled,
                  focused: false,
                  errored,
                  valid: isValidating,
                  scheme,
                })}
              >
                {label}
              </Typography>
            ) : (
              <InputLabel
                id={fieldName}
                sx={labelSx({
                  labeled,
                  shouldShrink,
                  backgroundColorTitle,
                  startAdornment: null,
                  filled,
                  focused: false,
                  errored,
                  valid: isValidating,
                  scheme,
                })}
              >
                {label}
              </InputLabel>
            )}
            <Select
              fullWidth
              required={required}
              labelId={fieldName}
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              value={value}
              defaultValue={""}
              error={error?.type === "required"}
              onBlur={() => {
                onBlur()
                if (onFieldExit) {
                  onFieldExit()
                }
              }}
              onChange={onChange}
              inputRef={ref}
              inputProps={inputProps}
              sx={selectSx({
                errored: invalid,
                valid: !invalid && !isTouched && !isDirty,
                filled: !!value,
                rounded: variant === "rounded",
                borderRadius,
                scheme,
                overrides,
                size,
              })}
              /*sx={{
              backgroundColor: "white",
              height: size === "small" ? "42px" : undefined,
              borderRadius:
                variant === "rounded"
                  ? "50px"
                  : size === "small"
                  ? "6px"
                  : radiusCss,
              ".MuiOutlinedInput-notchedOutline": {
                border:
                  size === "small" ? "1px solid #BCC1FF" : "2px solid #BCC1FF",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${primaryColor}`,
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #BCC1FF",
              },
              ".MuiSvgIcon-root ": {
                fill: "#7E86A0 !important",
              },
              "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: "#BCC1FF",
                borderWidth: size === "small" ? "1px" : "2px",
              },
            }}*/
              IconComponent={() => (
                <IconButton onClick={() => setOpen(!open)} disabled={disabled}>
                  {open ? (
                    <KeyboardArrowUpIcon color="info" />
                  ) : (
                    <KeyboardArrowDownIcon color="disabled" />
                  )}
                </IconButton>
              )}
            >
              {children}
            </Select>
            {invalid && (
              <Typography variant="overline" color={"red"}>
                Campo {`"${label}"`} obrigatório
              </Typography>
            )}
          </FormControl>
        )
      }}
    />
  )
}

export default SelectRequired
